import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/client'
import Dashboard from '@wrappers/Dashboard'
import { Title } from '@lib'
import { Input } from '@shared/Form'

import resourcesGql from '@graphql/queries/resources'
import ResourceCard from '@shared/ResourceCard'

const Content = ({ user }) => {
  const [searchTerm, setSearchTerm] = useState('')

  const resourcesQuery = useQuery(resourcesGql, {})

  if (resourcesQuery.loading || resourcesQuery.error) {
    return null
  }
  const { resources } = resourcesQuery.data

  return (
    <Fragment>
      <Title text='Training Courses' user={user}/>

      <div className='training-courses-view'>
        <div id='resource-blurb-container'>
          <Input
            className='resource-search single'
            icon='far fa-search fa-lg'
            iconRight={true}
            type='text'
            placeholder='Search...'
            onChange={(v) => setSearchTerm(v)}
            dataAttrId="training_courses_search_field"
          />
        </div>
        <div className='resource-cards-wrapper'>
          {resources.map((x, key) =>
            ((x.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1 || (x.summary || '').toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1) &&
              <ResourceCard key={key} resource={x} />
            )
          )}
        </div>
      </div>

    </Fragment>
  )
}

Content.propTypes = {
  user: PropTypes.object
}

const Trainings = () => {
  return (
    <Dashboard>
      <Content/>
    </Dashboard>
  )
}

export default Trainings
